// extracted by mini-css-extract-plugin
export default {"module":"select_module__A9RND","title":"select_title__m2Hig","select":"select_select__VZ-Kl"};